import { useTranslation } from "react-i18next";
import {
  FaCar,
  FaRoute,
  FaTaxi,
  FaUserTie,
  FaWallet,
} from "react-icons/fa";
import {
  MdOutlinePayments,
  MdSupervisedUserCircle,
} from "react-icons/md";
import { RiDashboardFill } from "react-icons/ri";
import { SiSimpleanalytics } from "react-icons/si";
import { TbApps } from "react-icons/tb";
import { BsRobot } from "react-icons/bs";
import { GrTransaction } from "react-icons/gr";
import Sidebar from "../Sidebar";

const RideShareSideMenu = ({ setCollapsedFromSidebar, isCollapsed }) => {
  const { t } = useTranslation();

  const menus = [
    // {
    //   type: "link",
    //   text: t("ask_ai"),
    //   icon: <BsRobot />,
    //   to: "/ask-ai",
    // },
    {
      type: "link",
      text: t("dashboard"),
      icon: <RiDashboardFill />,
      to: "/rideshare/dashboard",
    },
    {
      type: "link",
      text: "Switch Project",
      icon: <TbApps />,
      to: "/switch-project",
    },
    {
      type: "link",
      text: "Drivers",
      icon: <FaUserTie />,
      to: "/rideshare/drivers",
    },
    {
      type: "link",
      text: "Fleet / Vehicles",
      icon: <FaCar />,
      to: "/rideshare/vehicles",
    },
    {
      type: "link",
      text: "Rides",
      icon: <FaTaxi />,
      to: "/rideshare/rides",
    },
    {
      type: "link",
      text: "Routes",
      icon: <FaRoute />,
      to: "/rideshare/routes",
    },
    {
      type: "link",
      text: "Customers",
      icon: <MdSupervisedUserCircle />,
      to: "/rideshare/customers",
    },
    {
      type: "dropdown",
      text: "Payments",
      icon: <GrTransaction />,
      children: [
        {
          type: "link",
          text: "Payment History",
          icon: <MdOutlinePayments />,
          to: "/rideshare/payment-history",
        },
        {
          type: "link",
          text: "Driver Earnings",
          icon: <FaWallet />,
          to: "/rideshare/driver-earnings",
        },
      ],
    },
    {
      type: "link",
      text: `${t("reporting")} ${t("and")} ${t("analytics")}`,
      icon: <SiSimpleanalytics />,
      to: "/rideshare/analytics",
    },
  ];

  return (
    <Sidebar
      setCollapsedFromSidebar={setCollapsedFromSidebar}
      menu={menus}
      isCollapsed={isCollapsed}
      title="Rideshare"
    />
  );
};

export default RideShareSideMenu;
